import { render, staticRenderFns } from "./Cabin.vue?vue&type=template&id=ee89b71c&scoped=true"
import script from "./Cabin.vue?vue&type=script&lang=js"
export * from "./Cabin.vue?vue&type=script&lang=js"
import style0 from "./Cabin.vue?vue&type=style&index=0&id=ee89b71c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee89b71c",
  null
  
)

export default component.exports